export enum ReportScopeEnum {
    Externo = 1,
    Interno = 2
}